export enum Permissions {
  ViewTickets = 'view_tickets',
  ViewCompanyTickets = 'view_company_tickets',
  RaiseBilling = 'raise_billing',
  RaiseIncident = 'raise_incident',
  RaiseRequest = 'raise_request',
  ViewRequests = 'view_requests',
  ViewReports = 'view_reports',
  ViewPublisherUpdates = 'view_publisher_updates',
  ViewPublisherUpdateContracts = 'view_publisher_update_contract',
  ViewAutomations = 'view_automation',
  ViewMyProjects = 'view_myProjects',
}
